import { render, staticRenderFns } from "./EmailActivity.vue?vue&type=template&id=ffcab424&"
import script from "./EmailActivity.vue?vue&type=script&lang=js&"
export * from "./EmailActivity.vue?vue&type=script&lang=js&"
import style0 from "./EmailActivity.vue?vue&type=style&index=0&id=ffcab424&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports